import React, {Component} from 'react';
import T from "i18n-react/dist/i18n-react";
import {Row, Col, Card, FormRow, FormField, FormInput, Button, Checkbox} from 'elemental-react16';
import '../../node_modules/elemental-react16/less/elemental.less';
import moment from 'moment';

class Banner extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showCart: false,
            cart: this.props.cartItems,
            mobileSearch: false,
            nameCustDiscount: '',
            emailCustDiscount: '',
            acceptPrivacyPromoProd : false
        };
    }

    capFirstLetter = (string) => {
        return string.charAt(0).toUpperCase() + string.slice(1);
    };

    handleSubscriberName = (e) => {
        this.setState({
            nameCustDiscount: this.capFirstLetter(e.target.value)
        })
    };

    handleSubscriberEmail = (e) => {
        this.setState({
            emailCustDiscount: (e.target.value).toLowerCase()
        })
    };

    handleCheckboxInput = () => {
        this.setState((prevState) => {
            return {acceptPrivacyPromoProd: !prevState.acceptPrivacyPromoProd}
        })
    };

    subscribeToDiscount = () => {

        let _self = this;

        let name = this.state.nameCustDiscount;
        let email = (this.state.emailCustDiscount).toLowerCase();

        if (email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) {
            this.props.subscribersDiscountInstance.orderByChild('email').equalTo(email).once("value", function(snapshot) {

                if (snapshot.val() === null) {
                    if (name && email) {
                        let subscribers = _self.props.subscribersDiscountInstance.push();

                        subscribers.set({
                            "name": name,
                            "email": email,
                            "timestamp": moment().locale('it').format("YYYY-MM-DD HH:mm:ss"),
                        });
                        _self.setState({
                            nameCustDiscount: '',
                            emailCustDiscount: '',
                            acceptPrivacyPromoProd: false
                        }, () => {
                            alert(T.translate("labels.thanksForSubscribe"));
                        })
                    }
                } else {
                    _self.setState({
                        emailCustDiscount: ''
                    }, () => {
                        alert(T.translate("labels.emailExist"));
                    });
                }
            });
        } else {
            this.setState({
                nameCustDiscount: '',
                emailCustDiscount: '',
                acceptPrivacyPromoProd: false
            }, () => {
                alert(`Email${T.translate("labels.isInvalid")}`);
            });
        }
    };

    render() {

        return(
            <Card className="home-banner">
                <Row>
                    <Col xs="100%" sm="100%" lg="1/2" style={{padding: 15}}>
                        <p>
                            {T.translate("labels.bannerText1")}<br />
                            {T.translate("labels.bannerText2")}
                        </p>
                        <hr/>
                        <FormRow>
                            <FormField label={T.translate("labels.nameSurname")}>
                                <FormInput name="nameCustDiscount"
                                           value={this.state.nameCustDiscount}
                                           onChange={this.handleSubscriberName} />
                            </FormField>
                        </FormRow>
                        <FormRow>
                            <FormField label={T.translate("labels.email")}>
                                <FormInput name="emailCustDiscount"
                                           value={this.state.emailCustDiscount}
                                           onChange={this.handleSubscriberEmail} />
                            </FormField>
                        </FormRow>
                        <FormRow>
                            <Checkbox checked={this.state.acceptPrivacyPromoProd}
                                      name="acceptPrivacyPromoProd"
                                      onClick={this.handleCheckboxInput} style={{float: 'left', width: '4%'}} />
                            <span className="label-checkbox">
                                {T.translate("labels.acceptPrivacyPromoProd")}
                                <a href="http://www.bestwaycorp.it/Footer/Policy" target="_blank">{T.translate("labels.linkPrivacy")}</a>
                                {T.translate("labels.acceptPrivacyPromoProd1")}
                            </span>
                            <Button disabled={!this.state.acceptPrivacyPromoProd || this.state.nameCustDiscount === '' || this.state.emailCustDiscount === ''}
                                    size="lg"
                                    onClick={this.subscribeToDiscount}>{T.translate("labels.confirmSubscribing")}</Button>
                        </FormRow>
                    </Col>
                    <Col xs="100%" sm="100%" lg="1/2" style={{padding: 15, textAlign: 'center'}}>
                        <img src={this.props.locale === 'it' ? "../img/flamingo.png" : "../img/flamingo-en.png"} alt="Flamingo Banner"/>
                    </Col>
                </Row>
            </Card>
        )
    }
};

export default Banner;


// WEBPACK FOOTER //
// ./src/components/Banner.js